import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';

// ducks
import { fetch } from '../../ducks/PropertySearch';
import { ADD_FAVORITE, REMOVE_FAVORITE, isFavorite } from '../../ducks/FavoriteSearch';

// components
import ClusterMap from '../../components/cluster-map/cluster-map';
import PropertyCard from '../../partials/property-card/property-card';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

// images
import EmptySelection from './images/empty-selection.png';

class PropertyResultsMap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: null
    };
  }
  render() {
    const {
      listId,
      ids,
      isLoading,
      view,
      record,
      pathname,
      search,
      isFavorite,
      ADD_FAVORITE,
      REMOVE_FAVORITE,
      ...props
    } = this.props;
    const { selected } = this.state;

    return (
      <Row className={BS.h100}>
        <Col xs={12} md={{ size: true }}>
          <ClusterMap
            mapProps={{
              center: { lat: 26.212878, lng: -81.718964 },
              zoom: 11
            }}
            bootstrapURLKeys={{
              key: process.env.REACT_APP_GOOGLE_MAP_API_KEY
            }}
            {...props}
            markers={this.getMarkers()}
            onMarkerClick={(props, markerKey, markerProps) => {
              const id = markerKey.split('_').pop();
              if (markerProps.points.length === 1) {
                this.setState({
                  selected: this.state.selected === id ? null : id
                });
              }
            }}
          />
        </Col>
        <Col
          xs={12}
          md={{ size: 'auto' }}
          className={cx(styles.propertyCardWrap, BS.mt3, BS.mtMd0)}
        >
          {isLoading && <div className={BS.loadingMask}>LOADING</div>}
          {selected && (
            <PropertyCard
              data={record.toJS()}
              className={styles.propertyCard}
              pathname={pathname}
              search={search}
              isFavorite={isFavorite}
              onFavoriteClick={() =>
                isFavorite ? REMOVE_FAVORITE(record.id) : ADD_FAVORITE(record)
              }
            />
          )}
          {!selected && (
            <div className={cx(styles.propertyCard, BS.textCenter)}>
              <img
                className={BS.imgFluid}
                src={EmptySelection}
                alt="Select a map marker to display the details"
              />
            </div>
          )}
        </Col>
      </Row>
    );
  }

  getMarkers() {
    const { selected } = this.state;
    const markers = this.props.latLongs.map(function (latLong, i) {
      return {
        id: latLong[2],
        lat: latLong[0],
        lng: latLong[1],
        selected: !!selected && latLong[2] === selected
      };
    });

    return markers;
  }

  componentDidUpdate(prevProps, prevState) {
    const { selected } = this.state;

    if (selected && selected !== prevState.selected) {
      this.checkAndLoad();
    }
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, propertyClass } = this.props;
    const { selected } = this.state;

    if (
      (!loaded || loaded !== selected) &&
      !isLoading &&
      (!error || loaded !== selected)
    ) {
      load({ id: selected, propertyClass });
    }
  }
}

export default connect(
  (state, props) => {
    const paginator = getPaginator(props.listId, state),
      results = paginator.getIn(['results']),
      record = state.PropertySearch.getIn(['detail', 'record']);

    return {
      latLongs: results
        .map(result => {
          return [
            parseFloat(result.get('latitude'), 10),
            parseFloat(result.get('longitude'), 10),
            result.get('mlsNumber')
          ];
        })
        .toJS()
        .filter(([lat, lng]) => !isNaN(lat) && !isNaN(lng)),
      record,
      isLoading: state.PropertySearch.getIn(['detail', 'loading']),
      loaded: state.PropertySearch.getIn(['detail', 'loaded']),
      error: state.PropertySearch.getIn(['detail', 'error']),
      pathname: state.routing.location.pathname,
      search: state.routing.location.search,
      isFavorite: isFavorite(state, record.id)
    };
  },
  {
    load: fetch,
    ADD_FAVORITE,
    REMOVE_FAVORITE
  }
)(PropertyResultsMap);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertyResultsMap.js